<template>
  <GenericList api-endpoint="history" ref="GenericList" :modeEnable="true">
    <template v-slot:title>資料紀錄</template>
    <template v-slot:header>
      <HistoryHeader />
    </template>
    <template v-slot:modelabel>
      車流搜尋(專案名稱&收發器名稱)
    </template>
    <template v-slot:item="{ item, index }">
      <HistoryItem :item="item" :index="index" />
    </template>
  </GenericList>
</template>

<script>
import GenericList from '../generic/GenericSearchList.vue';
import HistoryHeader from '../device/HistoryHeader.vue';
import HistoryItem from '../device/HistoryItem.vue';

export default {
  components: {
    GenericList,
    HistoryHeader,
    HistoryItem,
  },
  methods: {
  },
};
</script>
